module.exports = __webpack_public_path__ + "static/media/podPurple.2caa2152.svg";